import { ClientActivityQueryParams, ClientTaskQueryParams } from '../model/client.model';
import { ActivityQueryParams, TaskQueryParams } from '../model/dashboard.model';

/*
 * File: huddle-api-constants.ts
 * Project: a-a
 * File Created: Thursday, 20th November 2025 9:43:24 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 12th December 2025 1:14:07 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
export class HuddleApiConstants {
  public static readonly DASHBOARD_API = {
    GET_DEAL: {
      URL: () => `sf/get_rollup_nums`,
    },
    GET_TASKS: {
      URL: () => `/huddle/sf/get_tasks?`,
      QUERY_PARAMS: (queryParams?: TaskQueryParams): string => {
        const validParams = Object.entries(queryParams || {}).filter(
          ([_, value]) => value != null && value !== '',
        );

        // Map the valid params into query string format and join them with '&'
        return validParams.map(([key, value]) => `${key}=${value}`).join('&');
      },
    },
    GET_ACTIVITY: {
      URL: () => `/huddle/sf/recent_activity?`,
      QUERY_PARAMS: (queryParams?: ActivityQueryParams): string => {
        const validParams = Object.entries(queryParams || {}).filter(
          ([_, value]) => value != null && value !== '',
        );

        // Map the valid params into query string format and join them with '&'
        return validParams.map(([key, value]) => `${key}=${value}`).join('&');
      },
    },
    GET_CLIENT: {
      URL: () => `sf/client_filter_values`,
    },
    GET_ACTION_ACCOUNT: {
      URL: () => `sf/actionable_accounts`,
    },
    GET_DROPDOWN: {
      URL: (email: string) => `/huddle/sf/task_dropdowns?mailId=${email}`,
    },

    HUDDLE_TASK: {
      URL: () => `/huddle/sf/task`,
    },
    EDIT_HUDDLE_TASK: {
      URL: (code: string) => `/huddle/sf/task/${code}`,
    },
    DELETE_HUDDLE_TASK: {
      URL: (code: string) => `/huddle/sf/task/${code}`,
    },
  };
  public static readonly CLIENT_API = {
    ALL_CLIENT: {
      URL: () => `/huddle/clients/all_clients`,
    },
    ADD_CLIENT: {
      URL: () => `/huddle/clients/client`,
    },
    DELETE_EDIT_CLIENT: {
      URL: (id: string) => `/huddle/clients/client/${id}`,
    },
    CLIENT_DETAILS: {
      URL: (id: string) => `/huddle/clients/client_profile_details?accountId=${id}`,
    },
    CLIENT_DROPDOWNS: {
      URL: (id: string) => `/huddle/clients/client_dropdowns?clientType=${id}`,
    },
    CLIENT_KEY_DEALS: {
      URL: (id: string) => `/huddle/clients/key_deals?accountId=${id}&`,
      QUERY_PARAMS: (queryParams?: any): string => {
        const validParams = Object.entries(queryParams || {}).filter(
          ([_, value]) => value != null && value !== '',
        );

        // Map the valid params into query string format and join them with '&'
        return validParams.map(([key, value]) => `${key}=${value}`).join('&');
      },
    },
    ADD_DEAL: {
      URL: () => `/huddle/clients/deal`,
    },
    EDIT_DEAL: {
      URL: (id: string) => `/huddle/clients/deal/${id}`,
    },
    ALL_PRICEBOOKS: {
      URL: () => `/huddle/clients/pricebooks`,
    },
    PRICEBOOK_PRODUCTS: {
      URL: (id: string) => `/huddle/clients/pricebook/${id}/products`,
    },
    DEAL_DROPDOWN: {
      URL: (id?: string) => `/huddle/clients/deal_dropdowns?${id ? '?id=' + id : ''}`,
    },
    CREATE_PRICEBOOK_PRODUCTS: {
      URL: () => `/huddle/clients/opplineitems/`,
    },
    EDIT_PRICEBOOK_PRODUCTS: {
      URL: (id: string) => `/huddle/clients/opplineitems/${id}`,
    },
    CLIENT_DEAL: {
      URL: (id: string) => `clients/client_rollup_nums?accountId=${id}`,
    },
    CLIENT_ACTIVITY: {
      URL: (id: string) => `/huddle/clients/client_activity?accountId=${id}&`,
      QUERY_PARAMS: (queryParams?: ClientActivityQueryParams): string => {
        const validParams = Object.entries(queryParams || {}).filter(
          ([_, value]) => value != null && value !== '',
        );

        // Map the valid params into query string format and join them with '&'
        return validParams.map(([key, value]) => `${key}=${value}`).join('&');
      },
    },
    GET_TASKS: {
      URL: (id: string) => `/huddle/clients/client_tasks?accountId=${id}&`,
      QUERY_PARAMS: (queryParams?: ClientTaskQueryParams): string => {
        const validParams = Object.entries(queryParams || {}).filter(
          ([_, value]) => value != null && value !== '',
        );

        // Map the valid params into query string format and join them with '&'
        return validParams.map(([key, value]) => `${key}=${value}`).join('&');
      },
    },
    GET_CONTACTS: {
      URL: (id: string) => `/huddle/clients/client_contacts?accountId=${id}`,
    },
    POST_CONTACT: {
      URL: () => `/huddle/clients/contact`,
    },
    UPDATE_CONTACT: {
      URL: (id: string) => `/huddle/clients/contact/${id}`,
    },
    DELETE_CONTACT: {
      URL: (id: string) => `/huddle/clients/contact/${id}`,
    },
  };
  public static readonly NOTES_API = {
    ALL_NOTES: {
      URL: (id: string) => `huddle/sf/notes/${id}?`,
      QUERY_PARAMS: (queryParams?: { access_token: string }): string => {
        const validParams = Object.entries(queryParams || {}).filter(
          ([_, value]) => value != null && value !== '',
        );

        // Map the valid params into query string format and join them with '&'
        return validParams.map(([key, value]) => `${key}=${value}`).join('&');
      },
    },
    ADD_EDIT_NOTES: {
      URL: () => `huddle/sf/notes`,
    },
    DELETE_NOTES: {},
  };
}
